import { createSlice } from "@reduxjs/toolkit";
import System from "../../../helper/system";

const setAllToURL = (data = {}) => {
    data = JSON.parse(JSON.stringify(data))
    let l = getAllFromURL()
    l.go = btoa(JSON.stringify(data))

    //This says that string is black-encoded
    if (l.go === 'e30=') {
        delete l.go;
    }
    history.replaceState(null, null, "?" + $.param(l));
}

const getAllFromURL = (l = false) => {
    if (!l) {
        l = System.getParams()
    }
    if (l.go !== undefined && l.go) {
        try {
            l.go = JSON.parse(atob(l.go))
        } catch (e) {
            l.go = {}
        }
    } else {
        l.go = {}
    }
    return l;
}

const slice = createSlice({
    name: "QuoteSearchListingFilterBox",
    // initialState: {},
    initialState: getAllFromURL().go,
    reducers: {
        loadData: {
            reducer: (state, action) => {
                state = action.payload.data;
                return state;
            },
        },
        updateSmartly: {
            reducer: (state, action) => {
                if (action.payload.status === true) {
                    state[action.payload.selection.slug] = action.payload.selection;
                }
                if (action.payload.status === false) {
                    delete state[action.payload.selection.slug];
                }
            },
        },
        clearFilterByKey: {
            reducer: (state, action) => {
                delete state[action.payload.key];
                setAllToURL(state)
                return state;
            },
        },
        clearAllFilter: {
            reducer: (state) => {
                state = {};
                setAllToURL(state)
                return state;
            },
        }
    }
})
    ;

export let { loadData, updateSmartly } = slice.actions;

export default slice.reducer;
